import type { Site } from '../Site';

export const Truly: Site = {
  id: 'truly',
  analyticsName: 'truly',
  selector: '',
  logo: '',
  label: 'Truly',
  platform: '',
};
